import { createListenerMiddleware } from '@reduxjs/toolkit';
import { navigateTo } from '../../core/navigation/navigationSlice.js';
import { modalActions } from './modalSlice.js';
import { dynamicMiddleware } from '../../store/index.js';
let modalNavigationMiddlewareInstance;
const modalNavigationMiddlewareOptions = {
    actionCreator: navigateTo,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        listenerApi.dispatch(modalActions.showModal(action.payload));
    },
};
const addModalNavigationMiddleware = () => {
    modalNavigationMiddlewareInstance = createListenerMiddleware();
    modalNavigationMiddlewareInstance.startListening(modalNavigationMiddlewareOptions);
    dynamicMiddleware.addMiddleware(modalNavigationMiddlewareInstance.middleware);
};
const removeModalNavigationMiddleware = () => {
    if (modalNavigationMiddlewareInstance) {
        dynamicMiddleware.removeMiddleware(modalNavigationMiddlewareInstance.middleware);
    }
};
export const modalNavigationMiddleware = {
    add: addModalNavigationMiddleware,
    remove: removeModalNavigationMiddleware,
};
//# sourceMappingURL=modalNavigationMiddleware.js.map